import { Store } from 'vuex'
import { createStore as createVueStore } from 'vuex-extensions'
import main from '@/store/modules/main'
import catalog from '@/store/modules/catalog'
import auth from '@/store/modules/auth'
import articles from '@/store/modules/articles'
import brands from '@/store/modules/brands'
import files from '@/store/modules/files'
import basket from '@/store/modules/basket'
import users from '@/store/modules/users'
import support from '@/store/modules/support'
import reporting from '@/store/modules/reporting'
import documents from '@/store/modules/documents'
import invoicesOlsa from '@/store/modules/invoicesOlsa'
import contracts from '@/store/modules/contracts'
import loyalty from '@/store/modules/loyalty'
import notifications from '@/store/modules/notifications'
import { ICatalogState } from '@/store/modules/catalog/interfaces/ICatalogState'
import { IAuthState } from '@/store/modules/auth/IAuthState'
import { IMainState } from '@/store/modules/main/intefaces/IMainState'
import { IArticlesState } from '@/store/modules/articles/interfaces/IArticlesState'
import { IBrandsState } from '@/store/modules/brands/interfaces/IBrandsState'
import orders, { IOrdersState } from './modules/orders'
import common, { ICommonState } from './modules/common'
import links from './modules/links'
import tickets from './modules/tickets'
import helpPages from './modules/help-pages'
import pageContents from './modules/page-contents'
import { IBasketState } from './modules/basket/interfaces/IBasketState'
import { IUsersState } from '@/store/modules/users/interfaces/IUsersState'
import { IFilesState } from '@/store/modules/files/interfaces/IFilesState'
import { ISupportState } from '@/store/modules/support/interfaces/ISupportState'
import { IReportingState } from '@/store/modules/reporting/interfaces/IReportingState'
import { ILinksState, IPortalHardCodeLinkState, IPortalPageMenuLinkState } from '@/store/modules/links/interfaces'
import { IHelpPagesState } from './modules/help-pages/interfaces'
import { IDocumentsState } from '@/store/modules/documents/interfaces/IDocumenstState'
import { IInvoicesOlsaState } from './modules/invoicesOlsa/interfaces/IInvoicesOlsaState'
import { IContractsState } from './modules/contracts/interfaces/IContractsState'
import { ITicketsState } from '@/store/modules/tickets/interfaces/ITicketsState'
import { IComment } from '@/store/modules/tickets/interfaces'
import { ILoyaltyState } from './modules/loyalty/interfaces'
import { IPageContentsState } from './modules/page-contents/interfaces'
import { INotificationState } from './modules/notifications/interfaces'

export interface IRootState {
  main: IMainState
  catalog: ICatalogState
  auth: IAuthState
  orders: IOrdersState
  articles: IArticlesState
  brands: IBrandsState
  files: IFilesState
  common: ICommonState
  basket: IBasketState
  users: IUsersState
  support: ISupportState
  reporting: IReportingState
  links: ILinksState & IPortalHardCodeLinkState & IPortalPageMenuLinkState
  tickets: ITicketsState
  helpPages: IHelpPagesState
  pageContents: IPageContentsState,
  documents: IDocumentsState
  invoicesOlsa: IInvoicesOlsaState
  contracts: IContractsState,
  loyalty: ILoyaltyState,
  notifications: INotificationState
}

export default function createStore (cache: any): Store<IRootState> {
  const options = {
    modules: {
      main,
      catalog,
      orders,
      auth,
      articles,
      brands,
      files,
      common,
      basket,
      users,
      support,
      reporting,
      links,
      tickets,
      helpPages,
      pageContents,
      documents,
      invoicesOlsa,
      contracts,
      loyalty,
      notifications
    },
    getters: {
      getCache (): any {
        return cache
      }
    },
    actions: {
      logout () {
        const lastStore = localStorage.getItem('store') as string
        const lastLang = localStorage.getItem('lang') as string
        const wasAgeConfirmed = localStorage.getItem('isSubmitAgeConfirmed')

        localStorage.clear()
        sessionStorage.clear()
        /* remove cookies */
        const dateTime = new Date()
        dateTime.setTime(dateTime.getTime())
        const expires = 'expires=' + dateTime.toUTCString()
        document.cookie = 'gmid' + '=' + '' + ';domain=gigya.com;path=/;' + expires
        document.cookie = 'hasGmid' + '=' + '' + ';domain=gigya.com;path=/;' + expires
        document.cookie = 'ucid' + '=' + '' + ';domain=gigya.com;path=/;' + expires
        document.cookie = 'private_content_version' + '=' + '' + ';domain=epartnerkp.pl;path=/;' + expires
        document.cookie = '_ga' + '=' + '' + ';domain=epartnerkp.pl;path=/;' + expires
        document.cookie = 'gig_loginToken_4_Zl2LiM4HKSwp_pQ31FmHdQ_revoked_tokens' + '=' + '' + ';domain=cdns.eu1.gigya.com;path=/;' + expires
        document.cookie = 'gig_bootstrap_4_4RahF2S8b2MvX-hqmTQHoA' + '=' + '' + ';domain=epartnerkp.pl;path=/;' + expires
        caches.keys().then((keyList) => Promise.all(keyList.map((key) => caches.delete(key))))
        if (lastLang === 'en') {
          localStorage.setItem('store', 'LivePortal_PL_en')
        } else {
          localStorage.setItem('store', 'LivePortal_PL_pl')
        }

        localStorage.setItem('lang', lastLang)

        if (wasAgeConfirmed) {
          localStorage.setItem('isSubmitAgeConfirmed', wasAgeConfirmed)
        }
      }
    }
  }

  return createVueStore(Store, options)
}
